const uriSerialize = function(obj) {
  var str = [];
  for(var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export const smartyValidateAddress = async (request_address) => {
    const endpoint_base = 'https://us-street.api.smartystreets.com/street-address?';

    let request_body = {
        'auth-id': '1489828000672374724',
        'license': 'us-core-enterprise-cloud',
        'match': 'enhanced',
        street: request_address.street,
        city: (typeof request_address.city === 'undefined' ? '' : request_address.city),
        state: (typeof request_address.state === 'undefined' ? '' : request_address.state),
        zipcode: request_address.zipcode
    };

    const response = await fetch(endpoint_base+uriSerialize(request_body));

    let json = null;
    try {
        json = await response.json();
    } catch (e) {
        console.log("SmartyStreets returned invalid JSON: ", e.message);
    }

    if(response.status < 200 || response.status >= 400) {
        const error = new Error(json && json.message || response.statusText);

        error.response = response;
        throw error;
    }

    let address = null;
    let is_secondary_suggested = false;
    if(json && json[0]) {
        address = json[0];

        is_secondary_suggested = (
            typeof address.analysis !== 'undefined'
            && typeof address.analysis.footnotes !== 'undefined'
            && address.analysis.footnotes.indexOf('H#') != -1
        );
    }

    const validation_response = {
        address: address,
        request_address: request_address,
        is_secondary_suggested: is_secondary_suggested
    }
    return validation_response;
}


// WEBPACK FOOTER //
// ./src/api/smartystreets.js